export const CRUMB_LABEL_KEY = 'edtZakazkaKorekce';
export const NAME = 'ZakazkaKorekce';
